"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGlobeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm12 13h-6a19.3 19.3 0 00-3.52-10.74A12 12 0 0128 15zM16 27.62C14.8 26.35 12.29 23 12 17h8c-.29 6-2.8 9.35-4 10.62zM12 15c.26-5.94 2.77-9.32 4-10.61A16.57 16.57 0 0120 15zm1.52-10.74A19.3 19.3 0 0010 15H4a12 12 0 019.52-10.74zM4.05 17h6a19.19 19.19 0 003.49 10.74A12 12 0 014.05 17zm14.44 10.74A19.28 19.28 0 0022 17h6a12 12 0 01-9.51 10.74z" })));
}
exports.default = SvgGlobeOutline;
//# sourceMappingURL=GlobeOutline.js.map